import { render } from "./Main.vue?vue&type=template&id=dfa8bb04"
const script = {}
script.render = render

export default script